import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';

export default class MultiSelectOptionViewModel extends ControlViewModel {

    /**
     * Gibt an, ob die Option selektiert ist
     */
    public isSelected: KnockoutObservable<boolean>;

    /**
     * Beinhaltet den Wert der Option
     */
    public value: KnockoutObservable<any>;

    /**
     * Beinhaltet das Label
     */
    public label: LabelViewModel;

    /**
     * Das ViewModel für den MultiSelectOption
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);

        this.isSelected = this.observableOrDefault(params.isSelected, false);
        this.value = this.observableOrDefault(params.value, null);
        this.label = this.paramOrDefault(params.label, null);
    }
}

ComponentManager.setViewModel('MultiSelectOptionViewModel', MultiSelectOptionViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');